import Box from "@material-ui/core/esm/Box";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AgreementsService } from 'api';
import { getAgreementAtom, getAgreementByIdRequestIdState } from 'api/agreements/getAgreementById';
import { getAgreementsRequestIdState } from 'api/agreements/getAgreementsAndVehicle';
import { EditButton } from 'components/Button';
import Dialog from 'components/Dialog/Dialog';
import { Input } from 'components/Form';
import { Info } from 'components/Text';
import useStyles from 'modules/Agreements/AgreementStyles';
import { trimWhitespace } from 'utils/text/trimWhitespace';
export default function ChangeAgreementName() {
  const {
    t
  } = useTranslation();
  const {
    changeName,
    row,
    editName
  } = useStyles();
  const {
    agreementId
  } = useParams();
  const [open, setOpen] = useState(false);
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [agreementName, setAgreementName] = useState('');
  const [requestId, setRequestId] = useRecoilState(getAgreementsRequestIdState);
  const [agreementIdRequestId, setAgreementIdRequestId] = useRecoilState(getAgreementByIdRequestIdState);
  const [agreement, setAgreement] = useRecoilState(getAgreementAtom(agreementId));
  const handleDialogClick = () => {
    setAgreementName('');
    setOpen(!open);
  };
  const submitName = async () => {
    if (agreement?.id) {
      try {
        setSaveIsLoading(true);
        const response = await AgreementsService.editAgreement({
          agreementId: agreement.id,
          body: {
            name: trimWhitespace(agreementName) || agreement.name,
            billingAddress: agreement.billingAddress,
            shippingAddress: agreement.shippingAddress
          }
        });
        if (response) {
          handleDialogClick();
          setAgreement(response);
          setRequestId(requestId + 1);
          setAgreementIdRequestId(agreementIdRequestId + 1);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setSaveIsLoading(false);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: changeName
  }, /*#__PURE__*/React.createElement("div", {
    className: row
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 2
  }, /*#__PURE__*/React.createElement(Info, null, t('agreements.agreement_name')), /*#__PURE__*/React.createElement("div", null, agreement.name)), /*#__PURE__*/React.createElement("div", {
    className: editName
  }, /*#__PURE__*/React.createElement(EditButton, {
    onClick: handleDialogClick
  }, t('agreements.change_agreement_name')))), /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: () => setOpen(false),
    isLoading: saveIsLoading,
    dialogTitle: t('agreements.change_agreement_name'),
    primaryBtnClickIsDisabled: !agreementName,
    onPrimaryBtnClick: submitName,
    primaryBtnTitle: t('buttons.save')
  }, /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, t('agreements.change_agreement_description')), /*#__PURE__*/React.createElement(Input, {
    editable: true,
    fullWidth: true,
    autoFocus: true,
    placeholder: agreement?.name || '',
    label: t('agreements.agreement_name'),
    onChange: setAgreementName
  }, agreementName)));
}